<template>
  <div class="edit-invoice pb-9">
    <v-card v-if="isLoading" flat>
      <div class="d-flex flex-column align-items-center mt-8 py-6">
        <cube></cube>
        <p class="c-purple font-weight-bold mt-4">در حال بارگذاری اطلاعات...</p>
      </div>
    </v-card>
    <div v-else>
      <!-- delete product dialog -->
      <v-dialog v-model="deleteModal" width="600">
        <v-card class="modal-card">
          <h5 class="dark-grey-color py-5">
            <v-icon color="error">$Alert</v-icon>
            <span class="ps-2 pe-2 pt-1"
              >آیا از حدف محصول {{ selectedItem.name }} اطمینان دارید؟</span
            >
          </h5>
          <div class="text-left mt-9">
            <v-btn
              class="purple-mainBtn"
              width="90"
              @click="removeItem(selectedIndex, selectedItem)"
              >بله</v-btn
            >
            <v-btn
              class="red-borderedBtn ms-2"
              width="90"
              @click="deleteModal = false"
              >بازگشت</v-btn
            >
          </div>
        </v-card>
      </v-dialog>
      <v-card class="common-card">
        <div class="d-flex flex-row">
          <h4 class="c-purple mt-0">ویرایش فاکتور</h4>
          <div v-if="invoiceData.type == 'proforma'" class="blue-badge ms-auto">
            پیش‌فاکتور
          </div>
          <div
            v-else-if="invoiceData.type == 'return'"
            class="pink-badge ms-auto"
          >
            مرجوعی
          </div>
        </div>

        <hr class="mt-5" />
        <div
          v-if="invoiceData.shopCustomerId"
          class="customer-info grey--text text--darken-2 mt-6 mb-3"
        >
          <v-row>
            <v-col>
              <b class="me-1">نام مشتری:</b>
              <span class="ms-2">{{ shopCustomerName }}</span>
            </v-col>
            <v-col>
              <b class="me-1">شماره همراه مشتری:</b>
              {{ customerMobile ? customerMobile : "-" }}
            </v-col>
          </v-row>
          <v-row v-if="!gettingBalance">
            <v-col>
              <b class="me-1">مانده حساب:</b>
              <span v-if="invoiceData.customerBalance" class="ms-2">{{
                invoiceData.customerBalance ? invoiceData.customerBalance : "-"
              }}</span>
            </v-col>
            <v-col>
              <b class="me-1">مبلغ کل پرداختی‌های پیشین:</b>
              {{
                allShopIncomeBalance
                  ? Number(allShopIncomeBalance).toLocaleString()
                  : "-"
              }}
              ریال
            </v-col>
          </v-row>
          <v-row>
            <!-- <v-col>
            <b class="me-1">میزان اعتبار باقی مانده:</b>
            {{ Number(royaltyCreditAmount).toLocaleString() }} ریال
          </v-col> -->
            <!-- <v-col>
            <b class="me-1">نوع اعتبار:</b> {{ royaltyCreditType }}
          </v-col> -->
          </v-row>
        </div>

        <hr />
        <span v-show="false">{{ reactivity }}</span>

        <v-row>
          <v-col>
            <v-btn
              @click="
                titleFilter = '';
                productsDialog = true;
                currentPage = 1;
              "
              height="50"
              class="purple-borderedBtn w-100"
              :class="!invoiceData.shopCustomerId ? 'disabled' : ''"
              ><v-icon class="me-2">$Box</v-icon> افزودن کالا با قیمت پیش‌ فرض
            </v-btn>
          </v-col>
          <v-col>
            <v-btn
              @click="
                titleFilter = '';
                productsIntendedDialog = true;
                currentPage2 = 1;
              "
              height="50"
              class="purple-borderedBtn w-100"
              :class="!invoiceData.shopCustomerId ? 'disabled' : ''"
              ><v-icon class="me-2">$Box</v-icon> افزودن کالا با قیمت دلخواه
            </v-btn>
          </v-col>
        </v-row>
        <div class="custom-table dashed mt-0 pb-2 mt-8">
          <b-table
            responsive
            show-empty
            :current-page="productCurrentPage"
            :per-page="productPerPage"
            :items="invoiceData.details"
            :fields="fields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="هنوز کالایی به فاکتور اضافه نشده است"
            striped
            thead-class="headClass"
            tbody-class="bodyClass"
          >
            <template v-slot:empty>
              <div
                style="text-align: center; vertical-align: middle"
                class="mt-2"
              >
                <v-icon class="red--text text--lightem-1 me-2"
                  >mdi-alert-circle-outline</v-icon
                >
                <span class="red--text font-weight-bold text--lightem-1"
                  >هنوز کالایی به فاکتور اضافه نشده است</span
                >
              </div>
            </template>
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:head(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 + productPerPage * (productCurrentPage - 1) }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(name)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  min-width: 300px;
                "
              >
                <span v-if="isPriceChanged(data)" class="me-1">*</span>
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(price)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.value).toLocaleString() }}
              </div>
            </template>
            <template v-slot:cell(amount)="data">
              <div
                style="text-align: center; vertical-align: middle"
                class="d-flex flex-row align-center"
              >
                <div class="d-flex">
                  <div
                    class="count-btn ms-"
                    @click="addItem(data.item, 1, data.index, 'direct')"
                    dir="ltr"
                  >
                    <span>+</span>
                  </div>
                </div>
                <div>
                  <v-text-field
                    class="countField ms-2 me-2"
                    outlined
                    dense
                    v-model="data.value"
                    hide-details
                    type="number"
                    @change="changeCount(data.item, data.value)"
                  ></v-text-field>
                </div>
                <div class="d-flex">
                  <div
                    class="count-btn"
                    @click="reduceItem(data.item, data.index, 1)"
                    dir="ltr"
                  >
                    <span>-</span>
                  </div>
                </div>
              </div>
            </template>
            <template v-slot:cell(totalPrice)="data">
              <div style="text-align: center; vertical-align: middle">
                <span v-show="false">{{ reactivity }}</span>
                {{
                  (Number(data.item.amount) * data.item.price).toLocaleString()
                }}
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div style="text-align: center; vertical-align: middle">
                <span
                  class="pointer"
                  @click="
                    openDeleteModal(
                      data.index + productPerPage * (productCurrentPage - 1),
                      data.item
                    )
                  "
                >
                  <v-icon>$Delete</v-icon></span
                >
              </div>
            </template>
          </b-table>
          <v-row class="mt-6">
            <v-col>
              <v-col class="d-flex flex-row">
                <span class="c-grey pt-2">نمایش در هر صفحه</span>
                <div class="ms-3 me-3 number-box-new">
                  <v-select
                    attach
                    :menu-props="{ bottom: true, offsetY: true }"
                    outlined
                    dense
                    v-model="productPerPage"
                    :items="perPageOptions"
                    @change="productCurrentPage = 1"
                  ></v-select>
                </div>
              </v-col>
            </v-col>
            <v-col>
              <div>
                <v-pagination
                  v-model="productCurrentPage"
                  :length="
                    Math.ceil(invoiceData.details.length / productPerPage)
                  "
                  :total-visible="5"
                  prev-icon="$ArrowLeft"
                  next-icon="$ArrowRight"
                  class="float-end"
                ></v-pagination>
              </div>
            </v-col>
          </v-row>
        </div>

        <div v-if="invoiceData.details.length">
          <hr />
          <v-row class="custom-input">
            <v-col md="6" cols="12">
              <span id="invoiceDate">
                <v-text-field
                  outlined
                  dense
                  type="text"
                  append-icon="mdi-calendar-edit"
                  v-model="invoiceData.date"
                  label="تاریخ"
                  :editable="true"
                  class="mt-2"
                  hide-details
                >
                </v-text-field>
              </span>

              <date-picker
                v-model="invoiceData.date"
                element="invoiceDate"
                color="#9c7fb7"
            /></v-col>
            <v-col md="6" cols="12">
              <span id="invoiceTime">
                <v-text-field
                  outlined
                  dense
                  type="text"
                  append-icon="mdi-calendar-edit"
                  v-model="invoiceData.time"
                  label="ساعت"
                  :editable="true"
                  class="mt-2"
                  hide-details
                >
                </v-text-field>
              </span>

              <date-picker
                v-model="invoiceData.time"
                element="invoiceTime"
                color="#9c7fb7"
                type="time"
            /></v-col>
          </v-row>
          <v-row>
            <v-col lg="6" md="12" cols="12">
              <div class="custom-input mb-7">
                <!--<v-checkbox
                  v-if="false"
                  v-model="useRoyaltyCredit"
                  label="استفاده از اعتبار"
                  class="mt-0 royaltyCredit"
                ></v-checkbox>-->

                <v-text-field
                  label="تخفیف (درصد)"
                  v-model="invoiceData.discountPercentage"
                  outlined
                  dense
                  hide-details
                  type="number"
                  min="0"
                  max="100"
                  oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; this.value = Math.abs(this.value)"
                  class="w-100"
                ></v-text-field>
              </div>
              <div class="custom-input mb-7">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  type="number"
                  min="0"
                  max="100"
                  oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; this.value = Math.abs(this.value)"
                  label="مالیات (درصد)"
                  class="w-100"
                  v-model="invoiceData.vat"
                ></v-text-field>
              </div>
              <div v-if="invoiceData.type == 'proforma'" class="custom-input">
                <h5>
                  <b class="primary--text">تاریخ انقضا: </b>
                  <span>{{
                    invoiceData.expirationDate
                      ? invoiceData.expirationDate
                      : "-"
                  }}</span>
                </h5>
              </div>
              <div v-else>
                <h5>
                  <b class="primary--text">نوع پرداخت: </b>
                  <span>{{
                    invoiceData.type == "respite"
                      ? "امانی - پرداخت اعتباری"
                      : invoiceData.type == "definite"
                      ? "قطعی - پرداخت در لحظه"
                      : "-"
                  }}</span>
                </h5>
              </div>
            </v-col>
            <v-col lg="6" md="12" cols="12">
              <div class="custom-input mt-1">
                <v-textarea
                  :rows="6"
                  no-resize
                  dense
                  outlined
                  hide-details
                  label="توضیحات"
                  v-model="invoiceData.description"
                >
                </v-textarea>
              </div>
            </v-col>
          </v-row>

          <div v-if="invoiceData.type == 'definite'" class="mt-5">
            <div class="custom-input mb-1">
              <v-select
                class="shop-select"
                attach
                :menu-props="{ bottom: true, offsetY: true }"
                dense
                outlined
                hide-details
                label="نحوه پرداخت"
                :items="paymentTypes"
                v-model="invoiceData.income.paymentType"
              >
                <template v-slot:append>
                  <v-icon>$ArrowDown</v-icon>
                </template>
              </v-select>
            </div>
            <div
              v-if="invoiceData.income.paymentType == 'cheque'"
              class="pa-5 pt-10 mb-2 mt-8"
              style="
                border: 1px solid #ccc;
                border-radius: 12px;
                position: relative;
              "
            >
              <p
                class="ps-4 pe-4 c-grey"
                style="position: absolute; top: -9px; background-color: #fff"
              >
                اطلاعات چک را وارد کنید:
              </p>
              <v-row class="custom-input">
                <v-col class="py-0" sm="6" cols="12">
                  <v-text-field
                    type="number"
                    label="شماره چک"
                    v-model="invoiceData.income.chequeNo"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

                <v-col class="py-0" sm="6" cols="12">
                  <v-text-field
                    label="نام بانک"
                    v-model="invoiceData.income.chequeBank"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="custom-input">
                <v-col class="py-0" sm="6" cols="12">
                  <v-text-field
                    type="number"
                    label="شماره صیاد"
                    v-model="invoiceData.income.chequeSayyad"
                    outlined
                    dense
                    class="my-3"
                  ></v-text-field>
                  <v-select
                    attach
                    :menu-props="{ bottom: true, offsetY: true }"
                    v-model="invoiceData.income.chequeStatus"
                    dense
                    outlined
                    hide-details
                    label="وضعیت چک"
                    :items="chequeStatuses"
                    class="mb-1"
                  >
                    <template v-slot:append>
                      <v-icon>$ArrowDown</v-icon>
                    </template>
                  </v-select>
                </v-col>
                <v-col class="pt-0" sm="6" cols="12">
                  <span id="checkDate">
                    <v-text-field
                      outlined
                      dense
                      type="text"
                      append-icon="mdi-calendar-edit"
                      v-model="invoiceData.income.chequeDate"
                      label="تاریخ چک"
                      :editable="true"
                      class="date-input my-3"
                    >
                    </v-text-field>
                  </span>

                  <date-picker
                    v-model="invoiceData.income.chequeDate"
                    element="checkDate"
                    color="#9c7fb7"
                  />
                </v-col>
                <v-col class="pt-0"> </v-col>
              </v-row>
              <div v-if="computedChequeInfo" class="d-flex flex-row">
                <v-icon class="red--text me-1">mdi-alert-circle-outline</v-icon>
                <span class="red--text"
                  >وارد کردن شماره چک، نام بانک و تاریخ چک الزامی است.</span
                >
              </div>
            </div>
            <div
              v-if="invoiceData.income.paymentType == 'cardTransfer'"
              class="pa-5 pt-10 mb-2 mt-8"
              style="
                border: 1px solid #ccc;
                border-radius: 12px;
                position: relative;
              "
            >
              <p
                class="ps-4 pe-4 c-grey"
                style="position: absolute; top: -9px; background-color: #fff"
              >
                اطلاعات کارت‌‌ها:
              </p>
              <v-row class="custom-input">
                <v-col md="6" cols="12">
                  <v-text-field
                    label="شماره کارت فرستنده"
                    v-model="invoiceData.income.buyerCardNumber"
                    outlined
                    dense
                    type="number"
                    hide-details
                    data-maxlength="16"
                    oninput="this.value=this.value.slice(0,this.dataset.maxlength)"
                  ></v-text-field>
                  <span v-if="invoiceData.income.buyerCardNumber">
                    <getBankNameFromCardNumber
                      :digits="invoiceData.income.buyerCardNumber"
                      v-slot="{ bankName }"
                    >
                      <h6 v-if="bankName" class="me-3 mt-3">
                        نام بانک: {{ bankName }}
                      </h6></getBankNameFromCardNumber
                    >
                  </span>
                </v-col>

                <v-col md="6" cols="12">
                  <v-text-field
                    label="شماره کارت گیرنده"
                    v-model="invoiceData.income.recipientCardNumber"
                    outlined
                    dense
                    type="number"
                    hide-details
                    data-maxlength="16"
                    oninput="this.value=this.value.slice(0,this.dataset.maxlength)"
                  ></v-text-field>
                  <span v-if="invoiceData.income.recipientCardNumber">
                    <getBankNameFromCardNumber
                      :digits="invoiceData.income.recipientCardNumber"
                      v-slot="{ bankName }"
                    >
                      <h6 v-if="bankName" class="me-3 mt-3">
                        نام بانک: {{ bankName }}
                      </h6></getBankNameFromCardNumber
                    >
                  </span>
                </v-col>
              </v-row>
              <div v-if="computedCardInfo" class="d-flex flex-row mt-5">
                <v-icon class="red--text me-1">mdi-alert-circle-outline</v-icon>
                <span class="red--text"
                  >وارد کردن شماره کارت فرستنده و گیرنده الزامی است.</span
                >
              </div>
            </div>
            <v-row v-if="invoiceData.income.isPartial" class="mt-2">
              <v-col class="d-flex">
                <h5 class="primary--text font-weight-bold me-2">
                  <v-icon class="me-1">mdi-cash</v-icon>
                  پرداخت ثبت شده جزیی است
                  <span class="grey--text text--darken-1">
                    ( مقدار پرداخت:
                    {{
                      Number(
                        invoiceData.income.partialAmount
                      ).toLocaleString() + " ریال "
                    }}
                    )
                  </span>
                </h5>
              </v-col>
            </v-row>
          </div>
          <v-row>
            <v-col>
              <div class="custom-input mt-5">
                <v-text-field
                  no-resize
                  dense
                  outlined
                  hide-details
                  label="متن زیر فاکتور"
                  v-model="invoiceData.subInvoiceLine"
                >
                </v-text-field>
              </div>
            </v-col>
          </v-row>
          <hr class="my-8" />
          <v-row class="c-grey" style="font-size: 17px">
            <v-col lg="6" md="12" cols="12">
              <v-row>
                <v-col>
                  <span> قیمت کل </span>
                </v-col>
                <v-col>
                  {{ Number(computedTotalPrice).toLocaleString() + " ریال " }}
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <span> تخفیف </span>
                </v-col>
                <v-col>
                  {{ computedTotalDiscount }}
                </v-col>
              </v-row>
              <!--<v-row v-if="invoiceData.useRoyaltyCredit">
                <v-col>
                  <span> مبلغ اعتبار </span>
                </v-col>
                <v-col>
                  {{ Number(royaltyCreditAmount).toLocaleString() + " ریال " }}
                </v-col>
              </v-row>-->
              <v-row>
                <v-col>
                  <span> مالیات </span>
                </v-col>
                <v-col>
                  {{
                    parseInt(
                      ((invoiceData.details
                        .map((x) => Number(x.price) * Number(x.amount))
                        .reduce((a, b) => a + b, 0) -
                        (invoiceData.details
                          .map((x) => Number(x.price) * Number(x.amount))
                          .reduce((a, b) => a + b, 0) *
                          invoiceData.discountPercentage) /
                          100) *
                        invoiceData.vat) /
                        100
                    ) > 0
                      ? parseInt(
                          ((invoiceData.details
                            .map((x) => Number(x.price) * Number(x.amount))
                            .reduce((a, b) => a + b, 0) -
                            (invoiceData.details
                              .map((x) => Number(x.price) * Number(x.amount))
                              .reduce((a, b) => a + b, 0) *
                              invoiceData.discountPercentage) /
                              100) *
                            invoiceData.vat) /
                            100
                        ).toLocaleString() + " ریال "
                      : 0
                  }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <hr class="mt-8 mb-4" />
          <v-row class="c-grey my-4" style="font-size: 19px">
            <v-col lg="6" md="12" cols="12" class="pb-0">
              <v-row>
                <v-col>
                  <span> مبلغ قابل پرداخت</span>
                </v-col>
                <v-col>
                  {{
                    !computedDiscount
                      ? "مبلغ کل فاکتور منفی شده است."
                      : computedDiscount
                  }}
                </v-col>
                <!--<v-col v-else-if="invoiceData.useRoyaltyCredit">
                  {{
                    royaltyCreditAmount >
                    invoiceData.details
                      .map((x) => Number(x.price) * Number(x.amount))
                      .reduce((a, b) => a + b, 0) *
                      (1 + Number(invoiceData.vat) / 100)
                      ? 0
                      : parseInt(
                          (invoiceData.details
                            .map((x) => Number(x.price) * Number(x.amount))
                            .reduce((a, b) => a + b, 0) -
                            Number(royaltyCreditAmount)) *
                            (1 + Number(invoiceData.vat) / 100)
                        ).toLocaleString() + " ریال "
                  }}
                </v-col>-->
              </v-row>
              <v-row v-if="invoiceData.income.isPartial">
                <v-col>
                  <span> مبلغ پرداخت جزئی</span>
                </v-col>
                <v-col>
                  {{
                    Number(invoiceData.income.partialAmount).toLocaleString() +
                    " ریال "
                  }}
                </v-col>
              </v-row>
            </v-col>
            <v-col class="text-left pb-0">
              <v-btn
                :disabled="computedBtn || !computedDiscount"
                @click="editInvoice()"
                class="purple-mainBtn"
                width="90"
                :loading="editBusy"
              >
                <span class="white--text">
                  <v-icon small class="white--text me-1"
                    >mdi-check-outline</v-icon
                  >
                  ثبت
                </span></v-btn
              >
            </v-col>
          </v-row>
        </div>
      </v-card>
      <v-snackbar v-model="snackbar" timeout="2000" color="green" top>
        <div class="w-100 text-center">
          <v-icon class="white--text me-1">mdi-check-decagram</v-icon>
          {{ text }}
        </div>
      </v-snackbar>
      <v-snackbar v-model="errorSnackbar" timeout="2000" color="red" top>
        <div class="w-100 text-center">
          <v-icon class="white--text me-1">mdi-alert-circle-outline</v-icon>
          موجودی انبار کافی نیست!
        </div>
      </v-snackbar>
      <!-- choose amount for product dialog -->
      <v-dialog v-model="fieldModal" width="400">
        <v-card class="shop-dialog">
          <v-card-title class="white">
            <v-row>
              <v-col>
                <h4 class="c-grey mb-0">تعداد محصول</h4>
              </v-col>
              <v-col class="text-left pt-2">
                <span class="pointer" @click="fieldModal = false">
                  <v-icon class="close-icon">$Close</v-icon>
                </span>
              </v-col>
            </v-row>
          </v-card-title>
          <hr class="mt-2 mb-8" />
          <v-card-text class="custom-input">
            <v-row>
              <v-col cols="12">
                <h6 class="mb-5">مقدار محصول مورد نظر خود را وارد نمایید:</h6>
                <div class="custom-input">
                  <v-text-field
                    outlined
                    dense
                    label="تعداد"
                    v-model="productsAmount"
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <div class="text-left ps-4 pe-5 pb-4">
            <v-btn
              @click="addProductItem(selectedRow, productsAmount)"
              :disabled="!productsAmount"
              class="purple-mainBtn white--text"
              width="90"
            >
              ثبت
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
      <!-- products dialog-->
      <v-dialog v-model="productsDialog" width="800" persistent>
        <v-card class="dialog-card">
          <div>
            <div class="d-flex flex-row justify-space-between pa-3">
              <div class="d-flex flex-row">
                <h4 class="mb-0 pt-2">محصولات</h4>
                <v-divider class="me-10 ms-10" vertical></v-divider>
                <div class="custom-input2">
                  <v-text-field
                    hide-details
                    outlined
                    dense
                    label="جستجو در عناوین محصولات..."
                    prepend-icon="$Search"
                    @input="
                      currentPage = 1;
                      reactivity = !reactivity;
                    "
                    v-model="titleFilter"
                  >
                    <template v-slot:append>
                      <v-icon
                        v-if="titleFilter.length"
                        class="red--text text--lighten-2"
                        @click="
                          titleFilter = '';
                          currentPage = 1;
                        "
                        >mdi-close-circle</v-icon
                      >
                    </template>
                  </v-text-field>
                </div>
                <v-divider class="me-10 ms-10" vertical></v-divider>
                <!-- <div class="custom-input2">
                <v-text-field
                  hide-details
                  outlined
                  dense
                  label="جستجو در شماره بارکد..."
                  prepend-icon="$Search"
                  @input="
                    currentPage = 1;
                    reactivity = !reactivity;
                  "
                  v-model="barcodeFilter"
                >
                  <template v-slot:append>
                    <v-icon
                      v-if="barcodeFilter.length"
                      class="red--text text--lighten-2"
                      @click="
                        barcodeFilter = '';
                        currentPage = 1;
                      "
                      >mdi-close-circle</v-icon
                    >
                  </template>
                </v-text-field>
              </div> -->
              </div>
              <span class="pointer" @click="productsDialog = false"
                ><v-icon class="close-icon">$Close</v-icon></span
              >
            </div>
            <hr />
            <div
              v-if="productsLoading"
              class="d-flex flex-column align-items-center mt-8 py-6"
            >
              <cube></cube>
              <span style="font-size: 16px">در حال بارگذاری ...</span>
            </div>
            <div v-else class="custom-table mt-5">
              <b-table
                responsive
                show-empty
                stacked="sm"
                :current-page="currentPage"
                :per-page="perPage"
                :items="computedProducts"
                :fields="productsFields"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد."
                striped
                thead-class="headClass"
                tbody-class="bodyClass"
              >
                <template v-slot:empty>
                  <div
                    style="text-align: center; vertical-align: middle"
                    class="pt-0"
                  >
                    رکوردی برای نمایش وجود ندارد.
                  </div>
                </template>
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:head(name)="data">
                  <div style="text-align: right; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 + perPage * (currentPage - 1) }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(name)="data">
                  <div
                    style="
                      text-align: right;
                      vertical-align: middle;
                      min-width: 200px;
                    "
                  >
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(price)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ Number(data.value).toLocaleString() }}
                  </div>
                </template>
                <template v-slot:cell(sum)="data">
                  <div
                    style="
                      text-align: center;
                      vertical-align: middle;
                      margin-top: -4px;
                    "
                  >
                    <div
                      v-if="Number(data.value) == 0"
                      class="red-badge mx-auto"
                    >
                      اتمام موجودی
                    </div>
                    <div v-else>{{ data.value }}</div>
                  </div>
                </template>

                <template v-slot:cell(operation)="data">
                  <span v-show="false">{{ reactivity }}</span>
                  <div
                    style="text-align: center; vertical-align: middle"
                    class="pt-0"
                  >
                    <v-tooltip
                      v-if="
                        !products2[data.index + perPage * (currentPage - 1)]
                          .manualPrice
                      "
                      top
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-btn
                            @click="
                              addItem(
                                data.item,
                                1,
                                data.index + perPage * (currentPage - 1),
                                'indirect'
                              );
                              products[
                                data.index + perPage * (currentPage - 1)
                              ].currentPrice = true;
                              products[
                                data.index + perPage * (currentPage - 1)
                              ].manualPrice = false;
                              reactivity = !reactivity;
                            "
                            class="purple-mainBtn"
                            width="40"
                            ><v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </span>
                      </template>
                      <span>افزودن یک قلم کالا</span>
                    </v-tooltip>
                    <v-tooltip v-else top>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-btn
                            disabled
                            @click="
                              addItem(
                                data.item,
                                1,
                                data.index + perPage * (currentPage - 1),
                                'indirect'
                              );
                              products[
                                data.index + perPage * (currentPage - 1)
                              ].currentPrice = true;
                              products[
                                data.index + perPage * (currentPage - 1)
                              ].manualPrice = false;
                              reactivity = !reactivity;
                            "
                            class="purple-mainBtn"
                            width="40"
                            ><v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </span>
                      </template>
                      <span> کالا مورد نظر با قیمت دلخواه به فاکتور اضافه شده است.</span>
                    </v-tooltip>
                    <v-tooltip
                      v-if="
                        !products2[data.index + perPage * (currentPage - 1)]
                          .manualPrice
                      "
                      top
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <span
                        v-bind="attrs"
                        v-on="on"
                        >
                        <v-btn
                          @click="openFieldModal(data.item)"
                          class="green-mainBtn ms-1"
                          width="60"
                          ><v-icon>mdi-plus</v-icon><v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </span>
                      </template>
                      <span>افزودن به مقدار دلخواه</span>
                    </v-tooltip>
                    <v-tooltip
                      v-else
                      top
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <span
                        v-bind="attrs"
                        v-on="on"
                        >
                        <v-btn
                          disabled
                          @click="openFieldModal(data.item)"
                          class="green-mainBtn ms-1"
                          width="60"
                          ><v-icon>mdi-plus</v-icon><v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </span>
                      </template>
                      <span> کالا مورد نظر با قیمت دلخواه به فاکتور اضافه شده است.</span>
                    </v-tooltip>
                    <!--<v-btn
                      @click="addItem(data.item, 1, 'direct')"
                      class="purple-mainBtn"
                      >افزودن به فاکتور</v-btn
                    >-->
                  </div>
                </template>
              </b-table>
              <div class="blue-custom-pagination mt-6">
                <v-pagination
                  v-model="currentPage"
                  :length="Math.ceil(products.length / perPage)"
                  :total-visible="5"
                  prev-icon="$ArrowLeft"
                  next-icon="$ArrowRight"
                  class="float-end"
                ></v-pagination>
              </div>
            </div>
            <hr />
            <div class="py-1">
              <div v-if="!products.length">
                <v-icon class="red--text text--lightem-1 me-2"
                  >mdi-alert-circle-outline</v-icon
                >
                <span class="red--text font-weight-bold text--lightem-1"
                  > کالا مورد نظر با قیمت دلخواه به فاکتور اضافه شده است.</span
                >
              </div>
              <div v-else>
                <v-icon class="purple-icon c-purple me-3">$BoxChecked</v-icon>
                <span class="c-purple"
                  >{{
                    invoiceData.details
                      .map((x) => Number(x.amount))
                      .reduce((a, b) => a + b, 0)
                  }}
                  کالا به فاکتور اضافه شد.</span
                >
                <v-btn
                  @click="productsDialog = false"
                  class="purple-borderedBtn ms-10"
                  >دیدن فاکتور</v-btn
                >
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>
      <!-- products intended dialog -->
      <v-dialog v-model="productsIntendedDialog" width="800" persistent>
        <v-card class="dialog-card">
          <div>
            <div class="d-flex flex-row justify-space-between pa-3">
              <div class="d-flex flex-row">
                <h4 class="mb-0 pt-2">محصولات</h4>
                <v-divider class="me-10 ms-10" vertical></v-divider>
                <div class="custom-input2">
                  <v-text-field
                    hide-details
                    outlined
                    dense
                    label="جستجو در محصولات..."
                    prepend-icon="$Search"
                    @input="
                      currentPage2 = 1;
                      reactivity = !reactivity;
                    "
                    v-model="titleFilter"
                  >
                    <template v-slot:append>
                      <v-icon
                        v-if="titleFilter.length"
                        class="red--text text--lighten-2"
                        @click="
                          titleFilter = '';
                          currentPage2 = 1;
                        "
                        >mdi-close-circle</v-icon
                      >
                    </template>
                  </v-text-field>
                </div>
                <v-divider class="me-10 ms-10" vertical></v-divider>
              </div>
              <span class="pointer" @click="productsIntendedDialog = false"
                ><v-icon class="close-icon me-5 mt-2">$Close</v-icon></span
              >
            </div>
            <hr />
            <div
              v-if="productsLoading"
              class="d-flex flex-column align-items-center mt-8 py-6"
            >
              <cube></cube>
              <span style="font-size: 16px">در حال بارگذاری ...</span>
            </div>
            <div v-else class="custom-table custom-intended-table mt-5">
              <b-table
                responsive
                show-empty
                stacked="sm"
                :current-page="currentPage2"
                :per-page="perPage2"
                :items="computedProducts2"
                :fields="productsFields"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد."
                striped
                thead-class="headClass"
                tbody-class="bodyClass"
              >
                <template v-slot:empty>
                  <div
                    style="text-align: center; vertical-align: middle"
                    class="pt-0"
                  >
                    رکوردی برای نمایش وجود ندارد.
                  </div>
                </template>
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:head(name)="data">
                  <div style="text-align: right; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 + perPage2 * (currentPage2 - 1) }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(name)="data">
                  <div
                    style="
                      text-align: right; 
                      vertical-align: middle;
                      min-width: 200px;
                    "
                  >
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(price)="data">
                  <div>
                    <vuetify-money
                      :valueWhenIsEmpty="whenIsEmpty"
                      :options="vMoneyOptions"
                      class="countField ms-2 me-2"
                      outlined
                      dense
                      v-model="data.value"
                      hide-details
                      type="number"
                      @input="
                        changePrice(
                          data.index + perPage2 * (currentPage2 - 1),
                          data.item,
                          data.value
                        )
                      "
                    />
                  </div>
                </template>
                <template v-slot:cell(sum)="data">
                  <span v-show="false">{{ reactivity }}</span>
                  <div
                    style="
                      text-align: center;
                      vertical-align: middle;
                      margin-top: -4px;
                    "
                  >
                    <div
                      v-if="Number(data.value) == 0"
                      class="red-badge mx-auto"
                    >
                      اتمام موجودی
                    </div>
                    <div v-else>{{ data.value }}</div>
                  </div>
                </template>

                <template v-slot:cell(operation)="data">
                  <span v-show="false">{{ reactivity }}</span>
                  <div
                    style="text-align: center; vertical-align: middle"
                    class="d-flex justify-space-between pt-0"
                  >
                    <v-tooltip
                      v-if="
                        !products[data.index + perPage2 * (currentPage2 - 1)]
                          .currentPrice
                      "
                      top
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-btn
                            @click="
                              reactivity = !reactivity;
                              data.item.manualPrice = true;
                              data.item.currentPrice = false;
                              addItemProduct2(
                                data.item,
                                1,
                                data.index + perPage2 * (currentPage2 - 1),
                                'indirect'
                              );
                            "
                            class="purple-mainBtn"
                            width="40"
                            ><v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </span>
                      </template>
                      <span>افزودن یک قلم کالا</span>
                    </v-tooltip>

                    <v-tooltip v-else top>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-btn
                            disabled
                            @click="
                              reactivity = !reactivity;
                              data.item.manualPrice = true;
                              data.item.currentPrice = false;
                              addItemProduct2(
                                data.item,
                                1,
                                data.index + perPage2 * (currentPage2 - 1),
                                'indirect'
                              );
                            "
                            class="purple-mainBtn"
                            width="40"
                            ><v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </span>
                      </template>
                      <span
                        > کالا مورد نظر با قیمت پیش فرض به فاکتور اضافه شده است.</span
                      >
                    </v-tooltip>

                    <v-tooltip
                      v-if="
                        !products[data.index + perPage2 * (currentPage2 - 1)]
                          .currentPrice
                      "
                      top
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-btn
                            @click="openFieldModal2(data.item)"
                            class="green-mainBtn ms-1"
                            width="60"
                            ><v-icon>mdi-plus</v-icon><v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </span>
                      </template>
                      <span>افزودن به مقدار دلخواه</span>
                    </v-tooltip>
                    <v-tooltip v-else top>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-btn
                            disabled
                            @click="openFieldModal2(data.item)"
                            class="green-mainBtn ms-1"
                            width="60"
                            ><v-icon>mdi-plus</v-icon><v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </span>
                      </template>
                      <span
                        > کالا مورد نظر با قیمت پیش فرض به فاکتور اضافه شده است.</span
                      >
                    </v-tooltip>
                  </div>
                </template>
              </b-table>
              <div class="blue-custom-pagination mt-6">
                <v-pagination
                  v-model="currentPage2"
                  :length="Math.ceil(computedProducts2.length / perPage2)"
                  :total-visible="5"
                  prev-icon="$ArrowLeft"
                  next-icon="$ArrowRight"
                  class="float-end"
                ></v-pagination>
              </div>
            </div>
            <hr />
            <div class="py-1">
              <div v-if="!products.length">
                <v-icon class="red--text text--lightem-1 me-2"
                  >mdi-alert-circle-outline</v-icon
                >
                <span class="red--text font-weight-bold text--lightem-1"
                  >هنوز کالایی به فاکتور اضافه نشده است.</span
                >
              </div>
              <div v-else>
                <v-icon class="purple-icon c-purple me-3">$BoxChecked</v-icon>
                <span class="c-purple"
                  >{{
                    invoiceData.details
                      .map((x) => Number(x.amount))
                      .reduce((a, b) => a + b, 0)
                  }}
                  کالا به فاکتور اضافه شد.</span
                >
                <v-btn
                  @click="productsIntendedDialog = false"
                  class="purple-borderedBtn ms-10"
                  >دیدن فاکتور</v-btn
                >
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>

      <!-- choose amount for product dialog -->
      <v-dialog v-model="fieldModal2" width="400">
        <v-card class="shop-dialog">
          <v-card-title class="white">
            <v-row>
              <v-col>
                <h4 class="c-grey mb-0">تعداد محصول</h4>
              </v-col>
              <v-col class="text-left pt-2">
                <span class="pointer" @click="fieldModal2 = false">
                  <v-icon class="close-icon">$Close</v-icon>
                </span>
              </v-col>
            </v-row>
          </v-card-title>
          <hr class="mt-2 mb-8" />
          <v-card-text class="custom-input">
            <v-row>
              <v-col cols="12">
                <h6 class="mb-5">مقدار محصول مورد نظر خود را وارد نمایید:</h6>
                <div class="custom-input">
                  <v-text-field
                    outlined
                    dense
                    label="تعداد"
                    v-model="productsAmount"
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <div class="text-left ps-4 pe-5 pb-4">
            <v-btn
              @click="addProductItem2(selectedRow, productsAmount)"
              :disabled="!productsAmount"
              class="purple-mainBtn white--text"
              width="90"
            >
              ثبت
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import { getBankNameFromCardNumber } from "@persian-tools/vue-persian-tools/dist/modules";
import moment from "moment-jalaali";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import prices from "../../mixins/prices";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    getBankNameFromCardNumber,
  },
  mixins: [prices],
  data() {
    return {
      selectedIndex: "",
      selectedItem: {},
      deleteModal: false,
      type: "editinvoice",
      isPartial: false,
      partialAmount: null,
      useRoyaltyCredit: false,
      tab: "tab1",
      moment: moment,
      productsDialog: false,
      getReceiptDialog: false,
      perPageOptions: [4, 10, 20],
      guide: false,
      reactivity: false,
      snackbar: false,
      errorSnackbar: false,
      busy: false,
      text: "",
      products: [],
      products2: [],
      titleFilter: "",
      //   barcodeFilter: "",
      perPage: 5,
      currentPage: 1,
      perPage2: 5,
      currentPage2: 1,
      productPerPage: 10,
      productCurrentPage: 1,
      productsDialog: false,
      productsIntendedDialog: false,
      productsLoading: false,
      customerMobile: null,
      shopCustomerName: null,
      receiptNumber: "",
      royaltyCreditAmount: null,
      allShopIncomeBalance: null,
      royaltyCreditType: "none",
      invoiceData: {
        invoiceId: "",
        shopCustomerName: "",
        amount: null,
        totalPrice: 0,
        customerBalance: "",
        shopCustomerId: null,
        paymentType: "",
        vat: 0,
        discount: 0,
        discountPercentage: 0,
        useCredit: false,
        totalCost: 0,
        startDate: null,
        type: "",
        chequeNo: 0,
        chequeDate: "",
        details: [],
        invoiceCode: 0,
      },
      gettingBalance: false,
      paymentTypes: [
        { value: "cash", text: "نقدی" },
        { value: "card", text: "کارتخوان" },
        { value: "cheque", text: "چک" },
        { value: "cardTransfer", text: "کارت به کارت" },
      ],
      fields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام محصول" },
        { key: "code", label: "کد محصول" },
        { key: "price", label: "قیمت واحد (ریال)" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "قیمت کل (ریال)" },
        { key: "operation", label: "عملیات" },
      ],
      receiptFields: [
        { key: "index", label: "ردیف" },
        { key: "warehouse", label: "انبار" },
        { key: "code", label: "کد کالا" },
        { key: "name", label: "شرح کالا" },
        { key: "price", label: "قیمت واحد (ریال)" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "جمع کل (ریال)" },
      ],
      productsFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام محصول" },
        { key: "code", label: "کد محصول" },
        { key: "price", label: "قیمت (ریال)" },
        { key: "sum", label: "موجودی انبار" },
        // { key: "barcode", label: "بارکد" },
        { key: "operation", label: "عملیات" },
      ],
      chequeStatuses: [
        { value: "passed", text: "پاس شده" },
        { value: "returned", text: "برگشت خورده" },
        { value: "submitted", text: "ثبت شده" },
      ],
      editBusy: false,
      isLoading: false,
      fieldModal: false,
      fieldModal2: false,
      selectedRow: {},
      productsAmount: null,
    };
  },
  methods: {
    // disableAddingProduct(item) {
    //   let myIndex = this.invoiceData.details.findIndex( p => p.id == item.id);
    //   return this.invoiceData.details[myIndex].manualPrice == true;
    // },
    changePrice(index, item, amount) {
      item.price = amount;
      this.reactivity = !this.reactivity;
    },
    isPriceChanged(data) {
      if (data.item.manualPrice) {
        return true;
      } else {
        return false;
      }
    },
    addProductItem(item, amount) {
      if (item.sum > 0 && item.sum >= amount) {
        let myIndex = this.products.findIndex(
          (product) => product.id == this.selectedRow.id
        );
        if (myIndex > -1) {
          this.snackbar = true;
          this.products[myIndex].sum =
            Number(this.products[myIndex].sum) - Number(amount);
        }

        let selecttedIndex = this.invoiceData.details.findIndex(
          (product) => product.id == this.selectedRow.id
        );
        if (selecttedIndex == -1) {
          this.snackbar = false;
          let thisItem = item;
          thisItem.amount = Number(amount);
          this.invoiceData.details.push(thisItem);
        } else {
          this.snackbar = false;
          this.invoiceData.details[selecttedIndex].amount =
            Number(this.invoiceData.details[selecttedIndex].amount) +
            Number(amount);
          this.reactivity = !this.reactivity;
        }
        this.text = amount + " عدد " + item.name + " به فاکتور افزوده شد";
        setTimeout(() => {
          this.snackbar = true;
        }, 100);
        this.products2[myIndex].sum = item.sum;
        this.products[myIndex].currentPrice = true;
        this.products[myIndex].manualPrice = false;
        this.reactivity = !this.reactivity;
        this.fieldModal = false;
      } else {
        this.snackbar = false;
        this.errorSnackbar = true;
      }
    },
    addProductItem2(item, amount) {
      if (item.sum > 0 && item.sum >= amount) {
        let myIndex = this.products2.findIndex(
          (product) => product.id == this.selectedRow.id
        );
        if (myIndex > -1) {
          this.snackbar = true;
          this.products2[myIndex].sum =
            Number(this.products2[myIndex].sum) - Number(amount);
        }

        let selecttedIndex = this.invoiceData.details.findIndex(
          (product) => product.id == this.selectedRow.id
        );
        if (selecttedIndex == -1) {
          this.snackbar = false;
          let thisItem = item;
          thisItem.amount = Number(amount);
          this.invoiceData.details.push(thisItem);
        } else {
          this.snackbar = false;
          this.invoiceData.details[selecttedIndex].amount =
            Number(this.invoiceData.details[selecttedIndex].amount) +
            Number(amount);
          this.reactivity = !this.reactivity;
        }
        this.text = amount + " عدد " + item.name + " به فاکتور افزوده شد";
        setTimeout(() => {
          this.snackbar = true;
        }, 100);
        this.products[myIndex].sum = item.sum;
        this.products2[myIndex].currentPrice = false;
        this.products2[myIndex].manualPrice = true;
        this.reactivity = !this.reactivity;
        this.fieldModal2 = false;
      } else {
        this.snackbar = false;
        this.errorSnackbar = true;
      }
    },
    openFieldModal(item) {
      this.selectedRow = item;
      this.productsAmount = 0;
      this.fieldModal = true;
    },
    openFieldModal2(item) {
      this.selectedRow = item;
      this.productsAmount = 0;
      this.fieldModal2 = true;
      this.reactivity = !this.reactivity;
    },
    changeCount(item, amount) {
      item.amount = amount;
      this.reactivity = !this.reactivity;
    },
    openDeleteModal(index, item) {
      this.selectedIndex = index;
      this.selectedItem = item;
      this.deleteModal = true;
    },
    getData() {
      this.isLoading = true;
      Axios.get(
        this.baseUrl + "/ppkpms/shop/sales/getData/" + this.$route.params.id,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.invoiceData = res.data;
            this.customerMobile = res.data.shopCustomerMobile;
            this.shopCustomerName = res.data.shopCustomerName;
            this.getBalance(this.invoiceData.shopCustomerId);
            this.isLoading = false;
          } else {
            this.toast(res.data, "error");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.toast(err.response, "error");
          this.isLoading = false;
        });
    },
    addItem(item, amount, index, type) {
      if (item.sum > 0) {
        let myIndex = this.invoiceData.details.findIndex(
          (product) => product.id == item.id
        );
        if (myIndex == -1) {
          this.snackbar = false;
          this.errorSnackbar = false;
          let thisItem = item;
          thisItem.amount = Number(amount);
          this.invoiceData.details.push(thisItem);
        } else {
          this.snackbar = false;
          this.errorSnackbar = false;
          this.invoiceData.details[myIndex].amount =
            Number(this.invoiceData.details[myIndex].amount) + Number(amount);
          this.reactivity = !this.reactivity;
        }
        item.sum--;
        this.products2[index].sum = item.sum;
        if (type == "indirect") {
          this.text = amount + " عدد " + item.name + " به فاکتور افزوده شد";
          setTimeout(() => {
            this.snackbar = true;
          }, 100);
        }
      } else {
        this.snackbar = false;
        this.errorSnackbar = true;
      }
    },
    addItemProduct2(item, amount, index, type) {
      if (item.sum > 0) {
        let myIndex = this.invoiceData.details.findIndex(
          (product) => product.id == item.id
        );
        if (myIndex == -1) {
          this.snackbar = false;
          this.errorSnackbar = false;
          let thisItem = item;
          thisItem.amount = Number(amount);
          this.invoiceData.details.push(thisItem);
        } else {
          this.snackbar = false;
          this.errorSnackbar = false;
          this.invoiceData.details[myIndex].amount =
            Number(this.invoiceData.details[myIndex].amount) + Number(amount);
          this.reactivity = !this.reactivity;
        }
        item.sum--;
        this.products[index].sum = item.sum;
        if (type == "indirect") {
          this.text = amount + " عدد " + item.name + " به فاکتور افزوده شد";
          setTimeout(() => {
            this.snackbar = true;
          }, 100);
        }
      } else {
        this.snackbar = false;
        this.errorSnackbar = true;
      }
    },
    removeItem(index, item) {
      this.invoiceData.details.splice(index, 1);
      this.invoiceData.details.forEach((x) => {
        if (x.id == item.id) {
          x.sum = x.sum + item.amount;
        }
      });
      this.products.forEach((x) => {
        if (x.id == item.id) {
          x.sum = x.sum + item.amount;
          x.manualPrice = false;
          x.currentPrice = false;
        }
      });
      this.products2.forEach((x) => {
        if (x.id == item.id) {
          x.sum = x.sum + item.amount;
          x.manualPrice = false;
          x.currentPrice = false;
        }
      });
      this.productCurrentPage = 1;
      this.deleteModal = false;
    },
    reduceItem(item, index, amount) {
      let myamount = item.amount;
      if (myamount <= amount) {
        this.invoiceData.details.splice(index, 1);
      } else {
        this.invoiceData.details[index].amount =
          Number(this.invoiceData.details[index].amount) - Number(amount);
        this.reactivity = !this.reactivity;
      }
      item.sum = item.sum + amount;
    },
    getBalance(customerId) {
      this.gettingBalance = true;
      this.invoiceData.customerBalance = "";
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/customerBalance",
        {
          shopCustomerId: customerId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            // this.royaltyCreditAmount = res.data.royaltyCreditAmount;
            this.allShopIncomeBalance = res.data.allShopIncomeBalance;
            // let royaltyCreditType = res.data.royaltyCreditType;
            // this.royaltyCreditType =
            //   royaltyCreditType == "normal"
            //     ? "معمولی"
            //     : royaltyCreditType == "vip"
            //     ? "ویژه"
            //     : "فاقد اعتبار";
            this.invoiceData.customerBalance = res.data.balanceData;
            if (this.invoiceData.customerBalance > 0) {
              this.invoiceData.customerBalance =
                this.invoiceData.customerBalance.toLocaleString() +
                " ریال بدهکار";
            } else if (this.invoiceData.customerBalance < 0) {
              this.invoiceData.customerBalance =
                Math.abs(this.invoiceData.customerBalance).toLocaleString() +
                " ریال بستانکار";
            } else {
              this.invoiceData.customerBalance = "تسویه";
            }
            this.gettingBalance = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    editInvoice() {
      this.editBusy = true;
      this.vLoading = true;
      let itemIds = this.invoiceData.details.map((x) => x.id);
      let totalCost;
      //let sum =
      //  this.invoiceData.details
      //    .map((x) => Number(x.price) * Number(x.amount))
      //    .reduce((a, b) => a + b, 0) *
      //  (1 + Number(this.invoiceData.vat) / 100);
      totalCost = parseInt(
        (this.invoiceData.details
          .map((x) => Number(x.price) * Number(x.amount))
          .reduce((a, b) => a + b, 0) -
          (this.computedTotalPrice * Number(this.invoiceData.discountPercentage)) /
              100) *
          (1 + Number(this.invoiceData.vat) / 100)
      );

      //else {
      //  if (this.royaltyCreditAmount <= sum) {
      //    totalCost = parseInt(
      //      (this.invoiceData.details
      //        .map((x) => Number(x.price) * Number(x.amount))
      //        .reduce((a, b) => a + b, 0) -
      //        Number(this.royaltyCreditAmount)) *
      //        (1 + Number(this.invoiceData.vat) / 100)
      //    );
      //  } else {
      //    totalCost = 0;
      //  }
      //}
      Axios.patch(
        this.baseUrl + "/ppkpms/shop/sales/edit/" + this.$route.params.id,
        {
          shopInvoiceId: this.$route.params.id,
          shopCustomerId: this.invoiceData.shopCustomerId,
          type: this.invoiceData.type,
          date: this.invoiceData.date + " " + this.invoiceData.time,
          paymentType:
            this.invoiceData.type == "definite"
              ? this.invoiceData.income.paymentType
              : undefined,
          totalCost: totalCost,
          vat: Number(this.invoiceData.vat),
          discount: this.computedTotalPrice * Number(this.invoiceData.discountPercentage) / 100,
          discountPercentage: Number(this.invoiceData.discount),
          itemIds: itemIds,
          details: this.invoiceData.details,
          chequeNo:
            this.invoiceData.income.paymentType == "cheque"
              ? this.invoiceData.income.chequeNo
                ? this.invoiceData.income.chequeNo
                : ""
              : undefined,
          chequeDate:
            this.invoiceData.income.paymentType == "cheque"
              ? this.invoiceData.income.chequeDate
                ? this.invoiceData.income.chequeDate
                : ""
              : undefined,
          chequeSayyad:
            this.invoiceData.income.paymentType == "cheque"
              ? this.invoiceData.income.chequeSayyad
                ? this.invoiceData.income.chequeSayyad
                : ""
              : undefined,
          chequeBank:
            this.invoiceData.income.paymentType == "cheque"
              ? this.invoiceData.income.chequeBank
                ? this.invoiceData.income.chequeBank
                : ""
              : undefined,
          chequeStatus:
            this.invoiceData.income.paymentType == "cheque"
              ? this.invoiceData.income.chequeStatus
                ? this.invoiceData.income.chequeStatus
                : ""
              : undefined,
          buyerCardNumber:
            this.invoiceData.income.paymentType == "cardTransfer"
              ? this.invoiceData.income.buyerCardNumber
                ? Number(this.invoiceData.income.buyerCardNumber)
                : ""
              : undefined,
          recipientCardNumber:
            this.invoiceData.income.paymentType == "cardTransfer"
              ? this.invoiceData.income.recipientCardNumber
                ? Number(this.invoiceData.income.recipientCardNumber)
                : ""
              : undefined,
          description: this.invoiceData.description
            ? this.invoiceData.description
            : "",
          subInvoiceLine: this.invoiceData.subInvoiceLine,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.editBusy = false;
          if (res.status == 200) {
            this.receiptNumber = res.data.invoiceCode;
            this.invoiceData.invoiceId = res.data.invoiceId;
            this.toast("فاکتور با موفقیت ویرایش شد", "success");
            // this.getReceiptDialog = true;
            if (this.invoiceData.type == "proforma") {
              this.$router.push(
                "/print/" + this.type + "/preinvoice/" + this.$route.params.id
              );
            } else {
              localStorage.setItem(
                "oldCustomerBalance",
                this.invoiceData.customerBalance
              );
              this.$router.push(
                "/print/" + this.type + "/invoice/" + this.$route.params.id
              );
            }

            this.vLoading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.vLoading = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
          this.vLoading = false;
          this.editBusy = false;
        });
    },
    getProducts() {
      this.productsLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/goods/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.products = res.data;
            this.products.forEach((p) => {
              p.manualPrice = false;
              p.currentPrice = false;
              this.invoiceData.details.forEach((product) => {
                if (product.id == p.id) {
                  p.manualPrice = product.manualPrice;
                  p.currentPrice = product.currentPrice;
                  this.reactivity = !this.reactivityl;
                }
              });
            });
            this.products2 = JSON.parse(JSON.stringify(this.products));
            this.products2.forEach((p) => {
              this.invoiceData.details.forEach((product) => {
                if (product.id == p.id) {
                  p.manualPrice = product.manualPrice;
                  p.currentPrice = product.currentPrice;
                  this.reactivity = !this.reactivityl;
                }
              });
              p.price = 0;
            });
            this.productsLoading = false;
          } else {
            this.toast(res.data, "error");
            this.productsLoading = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.productsLoading = false;
        });
    },
    // computedIcon(item) {
    //   if (item.royaltyTier == "coper") {
    //     return "/icons8-star-35(1).png";
    //   } else if (item.royaltyTier == "silver") {
    //     return "/icons8-star-35.png";
    //   } else if (item.royaltyTier == "gold") {
    //     return "/icons8-star-35(2).png";
    //   } else if (item.royaltyTier == "diamond") {
    //     return "/icons8-diamond-35.png";
    //   }
    // },
  },
  computed: {
    computedTotalDiscount() {
      let discount =
        parseInt(
          (this.invoiceData.details
            .map((x) => Number(x.price) * Number(x.amount))
            .reduce((a, b) => a + b, 0) *
            this.invoiceData.discountPercentage) /
            100
        ) > 0
          ? parseInt(
              (this.invoiceData.details
                .map((x) => Number(x.price) * Number(x.amount))
                .reduce((a, b) => a + b, 0) *
                this.invoiceData.discountPercentage) /
                100
            ).toLocaleString() + " ریال "
          : 0;
      return discount;
    },
    computedDiscount() {
      let result;
      parseInt(
        (this.computedTotalPrice - this.invoiceData.discountPercentage) *
          (1 + Number(this.invoiceData.vat) / 100)
      ) > 0
        ? (result =
            parseInt(
              (this.computedTotalPrice -
                (this.computedTotalPrice * Number(this.invoiceData.discountPercentage)) /
                  100) *
                (1 + Number(this.invoiceData.vat) / 100)
            ).toLocaleString() + " ریال ")
        : (result = false);

      return result;
    },
    computedProducts() {
      let filtered;
      filtered = this.products.filter(
        (x) =>
          x.name.toLowerCase().includes(this.titleFilter.toLowerCase()) ||
          x.code.toLowerCase().includes(this.titleFilter.toLowerCase())
      );
      return filtered;
    },
    computedProducts2() {
      let filtered;
      filtered = this.products2.filter(
        (x) =>
          x.name.toLowerCase().includes(this.titleFilter.toLowerCase()) ||
          x.code.toLowerCase().includes(this.titleFilter.toLowerCase())
      );
      return filtered;
    },
    computedTotalPrice() {
      let total = 0;
      this.invoiceData.details.forEach((x) => {
        total = total + Number(x.amount) * Number(x.price);
      });
      this.reactivity = !this.reactivity;
      return total;
    },
    computedChequeInfo() {
      if (this.invoiceData.income.paymentType == "cheque") {
        if (
          !this.invoiceData.income.chequeNo ||
          !this.invoiceData.income.chequeBank ||
          !this.invoiceData.income.chequeDate
        ) {
          return true;
        } else return false;
      } else return false;
    },
    computedCardInfo() {
      if (this.invoiceData.income.paymentType == "cardTransfer") {
        if (
          !this.invoiceData.income.recipientCardNumber ||
          !this.invoiceData.income.buyerCardNumber
        ) {
          return true;
        } else return false;
      } else return false;
    },
    computedBtn() {
      if (this.invoiceData.income.paymentType) {
        if (this.invoiceData.income.paymentType == "cardTransfer") {
          if (
            !this.invoiceData.income.recipientCardNumber ||
            !this.invoiceData.income.buyerCardNumber
          ) {
            return true;
          } else return false;
        } else if (this.invoiceData.income.paymentType == "cheque") {
          if (
            !this.invoiceData.income.chequeNo ||
            !this.invoiceData.income.chequeBank ||
            !this.invoiceData.income.chequeDate
          ) {
            return true;
          } else return false;
        } else return false;
      } else if(this.invoiceData.type == "respite") {
        return false

      } else if(this.invoiceData.type == "proforma") {
        return false
      }else return true;
    },
  },
  mounted() {
    this.getData();
    this.getProducts();
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("./../../assets/fonts/IRANSans(FaNum).ttf");
}
.edit-invoice {
  .dashed {
    min-height: 250px !important;
    .custom-input {
      .v-input__slot {
        width: 100% !important;
      }
      .v-text-field .v-input__control,
      .v-text-field fieldset {
        min-height: 50px !important;
      }
      .mdi:before {
        margin-top: 6px;
      }
    }
  }
  .count-btn {
    width: 30px;
    height: 30px;
    border-radius: 10px;
    background-color: #7e57c2;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
    user-select: none;
    font-size: 20px;
  }
  .royaltyCredit label {
    position: static !important;
  }
  .remove-btn {
    min-width: 30px;
    height: 26px;
    border: 1px solid #f3536e;
    border-radius: 4px;
    background-color: FFE4E9;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #f3536e;
    cursor: pointer;
    user-select: none;
  }
  .delete-btn {
    display: none;
  }
  .customer-info {
    font-size: 15px;
    background-color: #f2f2f2;
    border-radius: 15px;
    padding: 20px 30px;
  }
  .countField {
    width: 75px;
    border-radius: 8px;
    background-color: #fff;
  }
  .custom-table .bodyClass tr td div {
    padding-top: 0;
  }
}
.custom-intended-table .bodyClass tr td div {
  padding-top: 1px !important;
}
.dialog-card {
  border-radius: 15px !important;
  padding: 10px;

  .custom-table {
    max-height: 500px;
    overflow-y: auto;
    padding-left: 10px;

    &::-webkit-scrollbar {
      width: 8px !important;
      background-color: #ccc !important;
      border-radius: 4px !important;
    }
    &::-webkit-scrollbar {
      width: 8px !important;
      background-color: #ccc !important;
      border-radius: 4px !important;
    }
    &::-webkit-scrollbar-thumb {
      background: #979797c7 !important;
      border-radius: 4px !important;
    }
  }
  .custom-input {
    .v-input__slot {
      width: 100% !important;
    }
    .v-text-field .v-input__control,
    .v-text-field fieldset {
      min-height: 50px !important;
    }
    @media only screen and (max-width: 600px) {
      .v-input__slot {
        width: 50% !important;
      }
    }
  }
  .purple-icon {
    path {
      stroke: #7634d6;
    }
  }
}
.inputPrice >>> input[type="number"] {
  -moz-appearance: textfield;
}
.inputPrice >>> input::-webkit-outer-spin-button,
.inputPrice >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>
